import React, { ReactNode } from "react"
import _ from "lodash"
import { DashboardLayout } from "sharedTypes"
import { useSaveDashboardLayout } from "queries/events"
import CustomizableGrid from "./CustomizableGrid"
import { BlockId } from "../layout"
import { EventPhase } from "../phase"

type Props = {
  eventId: string
  phase: EventPhase
  layouts?: Record<string, DashboardLayout>
  canCustomize: boolean
  blocks: Partial<Record<BlockId, ReactNode>>
  onCustomizingChange: (customizing: boolean) => void
}

const PHASES: EventPhase[] = ["pre-event", "day-of", "post-event"]

const EventDetails = ({
  eventId, phase, layouts, canCustomize, blocks, onCustomizingChange,
}: Props) => {
  const saveLayouts = useSaveDashboardLayout(eventId)
  const saved = Object.fromEntries(PHASES.map((each) => [each, layouts?.[_.camelCase(each)]]))

  return (
    // A fresh grid per event and phase: an open Customize doesn't carry over.
    <CustomizableGrid
      key={`${eventId}:${phase}`}
      phase={phase}
      blocks={blocks}
      saved={saved}
      canCustomize={canCustomize}
      onSave={saveLayouts}
      onCustomizingChange={onCustomizingChange}
    />
  )
}

export default EventDetails
